import { inject, PLATFORM_ID } from '@angular/core';
import { LocalStorageService, ToastService } from '@client';
import { TOKEN_KEY } from '@common';
import { Router } from '@angular/router';
import { AdminStore } from '../stores/admin.store';
import { isPlatformServer } from '@angular/common';

export const AuthGuard = async () => {
  const adminStore = inject(AdminStore);
  const plaformId = inject(PLATFORM_ID);

  if (isPlatformServer(plaformId)) return false;
  const localStorageService = inject(LocalStorageService);
  const accessToken = localStorageService.get(TOKEN_KEY.ADMIN_ACCESS_TOKEN_KEY);
  const router = inject(Router);
  const toast = inject(ToastService);

  if (!accessToken) {
    router.navigate(['/login']);
    toast.error('로그인이 필요합니다.');
    return false;
  }

  await adminStore.fetch();

  return true;
};
